export const FormsListEng:any={
    "f433a": require('../forms/formEng/f433a.pdf'),
    "f433aoi": require('../forms/formEng/f433aoi.pdf'),
    "f433b": require('../forms/formEng/f433b.pdf'),
    "f433boi": require('../forms/formEng/f433boi.pdf'),
    "f433d": require('../forms/formEng/f433d.pdf'),
    "f433f": require('../forms/formEng/f433f.pdf'),
    "p5059": require('../forms/formEng/p5059.pdf'),
    "p1854": require('../forms/formEng/p1854.pdf'),
}
export const FormsListSn:any={
    "f433a": require('../forms/formSp/f433asp.pdf'),
    "f433aoi": require('../forms/formSp/f433aois.pdf'),
    "f433b": require('../forms/formSp/f433bsp.pdf'),
    "f433boi": require('../forms/formSp/f433bois.pdf'),
    "f433d": require('../forms/formSp/f433dsp.pdf'),
    "f433f": require('../forms/formSp/f433fsp.pdf'),
    "p5059": require('../forms/formSp/p5059sp.pdf'),
    "p1854": require('../forms/formSp/p1854sp.pdf'),
}

